// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsPaymentWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  ListingAlias,
  PreviewApplicationPaymentWebApiResponseDto,
  StartPaymentMethodSessionWebApiRequestDto,
  StartPaymentMethodSessionWebApiResponseDto,
  SubmitApplicationPaymentWebApiRequestDto,
  SubmitOrderWebApiResponseDto,
} from '../..';

interface GetRentalApplicationPriceInCentsParams {
  listingAlias?: ListingAlias;
}
interface PreviewApplicationPaymentParams {
  applicationId?: string;
  city: string;
  country: string;
  postalCode: string;
  stateOrProvince: string;
}

export const CappsPaymentWebApiHandler_getRentalApplicationPriceInCents_Path =
  '/api/web/renter/v1/payment/getRentalApplicationPriceInCents';

export const CappsPaymentWebApiHandler_getRentalApplicationPriceInCents = (
  getParams: GetRentalApplicationPriceInCentsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetRentalApplicationPriceInCentsParams, never, number>(
    {
      getParams: getParams,
      endpoint: CappsPaymentWebApiHandler_getRentalApplicationPriceInCents_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsPaymentWebApiHandler_previewApplicationPayment_Path =
  '/api/web/renter/v1/payment/previewApplicationPayment';

export const CappsPaymentWebApiHandler_previewApplicationPayment = (
  getParams: PreviewApplicationPaymentParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<PreviewApplicationPaymentParams, never, PreviewApplicationPaymentWebApiResponseDto>(
    {
      getParams: getParams,
      endpoint: CappsPaymentWebApiHandler_previewApplicationPayment_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsPaymentWebApiHandler_startPaymentMethodSession_Path =
  '/api/web/renter/v1/payment/startPaymentMethodSession';

export const CappsPaymentWebApiHandler_startPaymentMethodSession = (
  postData: StartPaymentMethodSessionWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    StartPaymentMethodSessionWebApiRequestDto,
    StartPaymentMethodSessionWebApiResponseDto
  >(
    {
      endpoint: CappsPaymentWebApiHandler_startPaymentMethodSession_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};

export const CappsPaymentWebApiHandler_submitApplicationPayment_Path =
  '/api/web/renter/v1/payment/submitApplicationPayment';

export const CappsPaymentWebApiHandler_submitApplicationPayment = (
  postData: SubmitApplicationPaymentWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SubmitApplicationPaymentWebApiRequestDto, SubmitOrderWebApiResponseDto>(
    {
      endpoint: CappsPaymentWebApiHandler_submitApplicationPayment_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};
